import { reactive } from 'vue';
import { appConfig } from '@/config';
export const projectBrand = reactive({ name: appConfig.appName, icon_url: '/img/ezlife-logo.png' });
let inFlight = null;
export function applyProjectBrand(value) {
  if (!value?.name) return;
  projectBrand.name = value.name;
  projectBrand.icon_url = new URL(value.icon_url || '/img/ezlife-logo.png', appConfig.serviceOrigin).href;
  document.title = document.documentElement.dataset.buildTarget === 'h5' ? `${value.name} H5` : value.name;
  for (const rel of ['icon','apple-touch-icon']) {
    let link=document.querySelector(`link[rel="${rel}"]`);
    if(!link){link=document.createElement('link');link.rel=rel;document.head.appendChild(link);}
    link.href=rel === 'apple-touch-icon' ? new URL(`/business-api/project-icon.php?v=${encodeURIComponent(value.version || 'default')}&size=180`, appConfig.serviceOrigin).href : projectBrand.icon_url;
  }
  let title=document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if(!title){title=document.createElement('meta');title.name='apple-mobile-web-app-title';document.head.appendChild(title);}
  title.content=value.name;
  let manifest=document.querySelector('link[rel="manifest"]');
  if(!manifest){manifest=document.createElement('link');manifest.rel='manifest';document.head.appendChild(manifest);}
  manifest.href=new URL(`/business-api/project-manifest.php?target=${document.documentElement.dataset.buildTarget === 'h5' ? 'h5' : 'web'}&v=${encodeURIComponent(value.version || 'default')}`,appConfig.serviceOrigin).href;
}
export function loadProjectBrand() {
  if(inFlight)return inFlight;
  inFlight=(async()=>{try{const response=await fetch(new URL('/business-api/project-brand.php',appConfig.serviceOrigin),{cache:'no-store'});const data=await response.json();if(response.ok&&data.ok)applyProjectBrand(data.brand);}catch{/* Keep the current brand during connection failures. */}finally{inFlight=null;}})();
  return inFlight;
}
